import styled from "@emotion/styled";

export const Heading = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
`;

export const ContentContainer = styled.div`
  > div + div {
    margin-block-start: 16px;
    padding-block-start: 16px;
    border-block-start: 2px solid #f7f6ef;
  }
`;
